import Logo from "../assets/mb_mailer.png"

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-blue-600 to-purple-700 text-white py-8">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
        {/* Logo/Brand */}
        <div className="w-[15%]">
          <img src={Logo} alt="MBMailer Logo" />
          </div>

        {/* Links */}
        <div className="flex space-x-6 text-sm font-medium">
          <a href="/" className="hover:underline">
            Home
          </a>
          <a href="/login" className="hover:underline">
            Login
          </a>
          <a href="/signup" className="hover:underline">
            Register
          </a>
          <a href="/howto" className="hover:underline">
            How to Use
          </a>
          <a href="/contact" className="hover:underline">
            Contact Us
          </a>
        </div>

        {/* Copy */}
        <div className="text-sm text-white/80 text-center md:text-right">
          © {new Date().getFullYear()} MBMailer. <br className="md:hidden" />
          Powered by <span className="font-semibold"><a href="https://mb-techs.com">MB-Techs llc</a></span>.
        </div>
      </div>
    </footer>
  );
}
